module.exports = __webpack_public_path__ + "media/images/athletes/2478-3426a27c36bfb9b604cb8dded466daff.png";